<template>
    <div class="container-fluid">
        <div>
            <h3>Custos com funcionários</h3>
        </div>
        <div class="filters">
            <span class="span-month">Editando Mês:</span>
            <date-picker
                v-model ="month"
                format="MMMM/YYYY"
                type="month"
                v-on:change="loadMonth"
            >
            </date-picker>
            <span class="span-import">Importar dados de:</span>
            <date-picker
                v-if="importFrom"
                v-model ="importFrom"
                format="MMMM/YYYY"
                type="month"
            >
            </date-picker>
            <button @click="importMonth" class="btn-import btn btn-primary">Importar</button>
        </div>
        <div class="row employee-costs" v-if="users.length && updateAll">
            <div class="header-fixed">
                <div class="header fake-table">
                    <div class="name">Nome</div>
                    <div class="user-data">FGTS</div>
                    <div class="user-data">Salário</div>
                    <div class="user-data">INSS</div>
                    <div class="user-data">13°</div>
                    <div class="user-data">1/3 férias</div>
                    <div class="user-data">FGTS s/ 13°</div>
                    <div class="user-data">Acréscimos</div>
                    <div class="user-data">Descontos</div>
                    <div class="user-data">Total</div>
                </div>
                <div class="header-total fake-table" v-if="shouldRefreshTotal">
                    <div class="name">Total</div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.fgts"
                            disabled
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.salary"
                            disabled
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.inss"
                            disabled
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.thirteenth_salary"
                            disabled
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.vacation"
                            disabled
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.fgts_without_thirteenth_salary"
                            disabled
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.additions"
                            disabled
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.discounts"
                            disabled
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="total.total"
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div v-for="user in users" :key="user.id">
                <div class="fake-table">
                    <div class="name">
                        {{ user.name }}
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            placeholder="FGTS"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].fgts"
                            v-on:keyup="updateSalary(user.id)"
                            v-on:blur="updateEmployeeCosts(user.id)"
                        />
                    </div>
                    <div class="user-data">
                        <input v-if="update[user.id]"
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].salary"
                            v-on:blur="updateEmployeeCosts(user.id)"
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].inss"
                            v-on:blur="updateEmployeeCosts(user.id)"
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].thirteenth_salary"
                            v-on:blur="updateEmployeeCosts(user.id)"
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].vacation"
                            v-on:blur="updateEmployeeCosts(user.id)"
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].fgts_without_thirteenth_salary"
                            v-on:blur="updateEmployeeCosts(user.id)"
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].additions"
                            v-on:blur="updateEmployeeCosts(user.id)"
                        />
                    </div>
                    <div class="user-data">
                        <input
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].discounts"
                            v-on:blur="updateEmployeeCosts(user.id)"
                        />
                    </div>
                    <div class="user-data">
                        <input
                            v-if="update[user.id]"
                            class="hide-input"
                            v-money="money"
                            v-model.lazy="employee_costs[user.id].total"
                            disabled
                        />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import DatePicker from 'vue2-datepicker';

    export default {
        name: 'EmployeeCosts',
        components: {
            DatePicker
        },
        data () {
            return {
                month: new Date(),
                importFrom: false,
                users: {},
                employee_costs: {},
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                update: {},
                updateAll: true,
                total: {
                    fgts: '0',
                    salary: '0',
                    inss: '0',
                    vacation: '0',
                    discounts: '0',
                    total: '0',
                    additions: '0',
                    fgts_without_thirteenth_salary: '0',
                    thirteenth_salary: '0'
                },
                shouldRefreshTotal: true
            }
        },
        mounted (){
            this.loadMonth()
            this.importFrom = new Date((new Date()).setMonth(this.month.getMonth() - 1))
        },
        methods: {
            updateSalary (user_id) {
                this.update[user_id] = false
                this.employee_costs[user_id].salary = (this.formatNumber(this.employee_costs[user_id].fgts) * 12.5).toFixed(2)
                this.update[user_id] = true
            },
            updateEmployeeCosts (user_id) {
                let data = this.employee_costs[user_id]
                data.year = this.month.getFullYear()
                data.month = this.month.getMonth() + 1
                axios.post('/api/employee_costs', data)
                    .then((response) => {
                        this.updateEmployeeTotal(response.data.data)
                        this.clearTotal()
                        this.recalculateTotal()
                    })
            },
            formatNumber (number) {
                if (!(number.indexOf('R$') === 0)) {
                    return number
                }
                return number.replace('R$ ', '').replaceAll('.', '').replaceAll(',', '.')
            },
            updateEmployeeTotal (employeeCost) {
                this.update[employeeCost.user_id] = false
                this.employee_costs[employeeCost.user_id].total = employeeCost.total
                this.update[employeeCost.user_id] = true
            },
            loadMonth () {
                this.clearTotal()
                axios
                    .get('/api/users/costs?year=' + this.month.getFullYear() + '&month=' + (this.month.getMonth() + 1))
                    .then((response) => {
                        this.users = response.data.data
                        for (let index in response.data.data) {
                            let data = response.data.data[index]
                            this.employee_costs[data.id] = { user_id: data.id }
                            this.$set(this.update, data.id, true)
                        }
                        axios
                            .get('/api/employee_costs?year=' + this.month.getFullYear() + '&month=' + (this.month.getMonth() + 1))
                            .then((response) => {
                                for (let index in response.data.data) {
                                    let data = response.data.data[index]
                                    this.updateAll = false
                                    this.updateTotal(data)
                                    this.employee_costs[data.user_id] = data
                                    this.updateAll = true
                                }
                            })
                    })
            },
            updateTotal (costs) {
                this.shouldRefreshTotal = false
                this.total.fgts = (this.parseNumber(this.total.fgts) + this.parseNumber(costs.fgts)).toFixed(2)
                this.total.salary = (this.parseNumber(this.total.salary) + this.parseNumber(costs.salary)).toFixed(2)
                this.total.inss = (this.parseNumber(this.total.inss) + this.parseNumber(costs.inss)).toFixed(2)
                this.total.vacation = (this.parseNumber(this.total.vacation) + this.parseNumber(costs.vacation)).toFixed(2)
                this.total.discounts = (this.parseNumber(this.total.discounts) + this.parseNumber(costs.discounts)).toFixed(2)
                this.total.total = (this.parseNumber(this.total.total) + this.parseNumber(costs.total)).toFixed(2)
                this.total.additions = (this.parseNumber(this.total.additions) + this.parseNumber(costs.additions)).toFixed(2)
                this.total.fgts_without_thirteenth_salary = (this.parseNumber(this.total.fgts_without_thirteenth_salary) + this.parseNumber(costs.fgts_without_thirteenth_salary)).toFixed(2)
                this.total.thirteenth_salary = (this.parseNumber(this.total.thirteenth_salary) + this.parseNumber(costs.thirteenth_salary)).toFixed(2)
                this.shouldRefreshTotal = true
            },
            clearTotal () {
                this.total = {
                    fgts: '0',
                    salary: '0',
                    inss: '0',
                    vacation: '0',
                    discounts: '0',
                    total: '0',
                    additions: '0',
                    fgts_without_thirteenth_salary: '0',
                    thirteenth_salary: '0'
                }
            },
            recalculateTotal () {
                for (let index in this.employee_costs) {
                    let data = this.employee_costs[index]
                    this.updateTotal(data)
                }
            },
            parseNumber (number) {
                return parseFloat(this.formatNumber(number))
            },
            importMonth () {
                let data = {
                    month: this.month.getMonth() + 1,
                    year: this.month.getFullYear(),
                    importFromMonth: this.importFrom.getMonth() + 1,
                    importFromYear: this.importFrom.getFullYear(),
                }
                this.$confirm(
                    {
                        title: 'Importar dados de ' + this.importFrom.toLocaleString('pt-BR', { month: 'long' }) +
                                ' para ' + this.month.toLocaleString('pt-BR', { month: 'long' }) + '?',
                        message: `Os dados do mês de `  + this.month.toLocaleString('pt-BR', { month: 'long' }) +
                                ' serão sobrescritos.',
                        button: {
                            no: 'Não',
                            yes: 'Sim'
                        },
                        callback: confirm => {
                            if (confirm) {
                                axios.post('/api/employee_costs/import', data)
                                    .then(() => {
                                        this.loadMonth()
                                    })
                            }
                        }
                    }
                )

            }
        }
    }
</script>

<style scoped lang="sass">
    .span-month
        margin-right: 10px
    .span-import
        margin: 0 10px
    .employee-costs
        margin-top: 20px
        width: 1451px
    .fake-table
        border: 1px solid
        display: inline-block

        .name
            display: inline-block
            width: 300px
            max-width: 300px
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
            padding: 8px
            margin-bottom: -8px

        .user-data
            overflow: hidden
            display: inline-block
            width: 125px
            border-left: 1px solid
            padding: 8px
            margin-bottom: -8px

        .hide-input
            width: 100%

    .header-fixed
        background: white
        position: -webkit-sticky
        position: sticky
        top: 40px
        padding-top: 5px

    .header-total
        background: #bdbdbd7a

        .hide-input:disabled
            color: black !important

    .btn-import
        margin-left: 20px
</style>
